import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { subscribe } from 'mqtt-react';
import moment from 'moment';

import NotificationBell from './NotificationBell';
import { setGeneralSuccess, startConfirm } from '../../UniversalModal/actions';
import { withMqtt } from '../../../../components/HOC/ConnectMqtt';
import { changeFilters } from '../../../../redux/genericAction';
import {
  getListManagerOrder,
  getOrderDetail,
} from '../../../../pages/Order/OrderManagement/actions';
import {
  removeNotificationBell,
  setNotificationBell,
  setRingBell,
} from '../../../../pages/Setting/actions';
import { getListIds } from '../../../../pages/Table/TableManagement/actions';
import {
  cancelOrderNowShip,
  getDetailOrderNowShip,
  retryOrderNowShip,
  sendNotifyOrderNowShip,
} from '../../../../pages/NowShip/OrderManagementNowShip/actions';

import { trans } from '../../../../localization';
import {
  decodeUtf8, getPermissionRestaurant,
  isAllowNotification,
  parseToInt,
  requestNotificationPermission,
  sendNotify,
} from '../../../../utils/utils';

import {
  EnumActionMqtt,
  EnumBellSound,
  EnumBookingNowShipStatus, EnumMerchantPermission,
  EnumNotificationBell,
  EnumOrderStatus,
  EnumPage,
  EnumPushTypeNowShip,
  findEnumById,
} from '../../../../constants/enum';
import {
  NOW_SHIP_MQTT_TOPIC,
  NOW_TABLE_MQTT_TOPIC,
  RESTAURANT_MQTT_TOPIC,
  TEMPLATE_NOTE_ID_NOT_FOUND_SHIPPER,
} from '../../../../constants/constants';

class NotificationBellWrapper extends React.Component {
  constructor(props) {
    super(props);

    const { restaurants, merchantTableInfos } = this.props;
    const listRestaurantSubscribes = getPermissionRestaurant(restaurants, EnumMerchantPermission.ORDER_ALL.id).map(
      restaurant => `${RESTAURANT_MQTT_TOPIC}${restaurant.restaurant_id}`,
    );

    const listTableSubscribes = merchantTableInfos.map(
      merchant => `${NOW_TABLE_MQTT_TOPIC}${merchant.id}`,
    );

    const listNowShipSubscribes = restaurants.map(
      restaurant => `${NOW_SHIP_MQTT_TOPIC}${restaurant.restaurant_id}`,
    );

    const listSubscribes = [
      ...listRestaurantSubscribes,
      ...listTableSubscribes,
      ...listNowShipSubscribes,
    ];

    this.NotificationOrderSubscribed = subscribe({
      topic: listSubscribes,
      dispatch: this.handleReceiveMessage,
    })(NotificationBell);
    requestNotificationPermission();
  }

  handleReceiveMessage = (topic, rawMessage) => {
    if (rawMessage.length === 0) {
      return;
    }
    // pattern: /topic/id
    const [, topicType, restaurantId] = /(\/.*\/)(.+)/.exec(topic);
    const message = JSON.parse(decodeUtf8(rawMessage));
    switch (topicType) {
      case EnumNotificationBell.ORDER.topic: {
        this.pushNotificationOrderAction(message, restaurantId);
        break;
      }
      case EnumNotificationBell.TABLE.topic: {
        this.pushNotificationTableAction(message, restaurantId);
        break;
      }

      default: {
        break;
      }
    }
  };

  pushNotificationOrderAction = (message, restaurantIdTopic) => {
    const typePushOrder = EnumNotificationBell.ORDER;
    const {
      currentRestaurant,
      location,
      history,
      isRingAllRestaurant,
      setNotificationBellConnect,
      setGeneralSuccessConnect,
      setRingBellConnect,
      startConfirmConnect,
      getListManagerOrderConnect,
      getOrderDetailConnect,
      removeNotificationBellConnect,
    } = this.props;
    const targetParam = new URLSearchParams(message.target);
    const status = parseToInt(targetParam.get('status'));
    const orderCode = targetParam.get('code');
    const action = targetParam.get('action');
    if (action === EnumActionMqtt.MARK_SEEM.message) {
      removeNotificationBellConnect(orderCode);
      return;
    }
    const messagePush = trans(findEnumById(EnumOrderStatus, status).message, [
      orderCode,
    ]);

    const restaurantId = parseToInt(restaurantIdTopic || 0);

    const notification = {
      id: parseToInt(message.push_id),
      message: messagePush,
      restaurantId,
      orderCode,
      type: typePushOrder.id,
      createDate: moment(),
      isCount: true,
    };
    setNotificationBellConnect(notification);

    if (
      currentRestaurant.restaurant_id === restaurantId ||
      isRingAllRestaurant
    ) {
      const { pathname } = location;
      this.sendNotificationBrowser(messagePush);
      if (pathname === typePushOrder.to) {
        getListManagerOrderConnect();
        if (!isAllowNotification()) {
          setGeneralSuccessConnect(messagePush);
        }
      } else {
        startConfirmConnect(
          messagePush,
          trans('merchant_order_view_order'),
          () => {
            history.push(typePushOrder.to);
            getOrderDetailConnect(orderCode);
          },
          () => {
            setRingBellConnect(false);
          },
        );
      }
      setRingBellConnect(true);
    }
  };

  pushNotificationTableAction = (message, restaurantIdTopic) => {
    const typePushTable = EnumNotificationBell.TABLE;
    const {
      location,
      history,
      merchantTableInfos,
      setNotificationBellConnect,
      setGeneralSuccessConnect,
      setRingBellConnect,
      startConfirmConnect,
      getListIdsConnect,
      handleChangeFiltersConnect,
    } = this.props;
    const { pathname } = location;
    const messagePush = trans('rebranding.mtn_notification_you_have_new_order');
    const restaurantId = parseToInt(restaurantIdTopic || 0);
    const notification = {
      id: 0,
      message: messagePush,
      restaurantId,
      orderCode: message.order_code,
      type: typePushTable.id,
      createDate: moment(),
      arriveTime: parseInt(message.arrive_time, 0) * 1000,
      isCount: true,
    };
    setNotificationBellConnect(notification);
    this.sendNotificationBrowser(messagePush);
    if (pathname === typePushTable.to) {
      getListIdsConnect();
      if (!isAllowNotification()) {
        setGeneralSuccessConnect(messagePush);
      }
    } else {
      startConfirmConnect(
        messagePush,
        trans('merchant_order_view_order'),
        () => {
          const restaurant = merchantTableInfos.find(
            m => m.id === restaurantId,
          );
          const { id: value, name: label } = restaurant;
          handleChangeFiltersConnect(EnumPage.TABLE_MANAGEMENT.id, 'merchant', {
            value,
            label,
          });
          history.push(typePushTable.to);
        },
        () => {
          setRingBellConnect(false);
        },
      );
    }
    setRingBellConnect(true);
  };

  pushNotificationShipAction = async (message, restaurantId) => {
    const {
      setNotificationBellConnect,
      setRingBellConnect,
      setGeneralSuccessConnect,
      cancelOrderNowShipConnect,
      retryOrderNowShipConnect,
      getDetailOrderNowShipConnect,
      location,
    } = this.props;
    const {
      message: notificationMessage,
      booking_code: bookingCode,
      status,
    } = message;
    const { push_type: pushType } = message;
    if (pushType === EnumPushTypeNowShip.CHANGE_ORDER_STATUS.id) {
      const { body } = notificationMessage.data;
      sendNotifyOrderNowShip(message);
      if (body) {
        const notification = {
          message: body,
          restaurantId,
          orderCode: bookingCode,
          type: EnumNotificationBell.SHIP.id,
          createDate: moment(),
          isCount: true,
        };
        setNotificationBellConnect(notification);
      }
      const restaurantIdInt = parseInt(restaurantId, 10);
      if (status === EnumBookingNowShipStatus.ASSIGNING_TIMEOUT.id) {
        setRingBellConnect(true, EnumBellSound.NOW_SHIP_ASSIGN_TIMEOUT.id);
        if (location.pathname.startsWith('/ship/')) {
          const {
            receiver_info: receiverInfo,
            drop_address_info: dropAddressInfo,
          } = await getDetailOrderNowShipConnect(
            bookingCode,
            true,
            restaurantIdInt,
          );
          setGeneralSuccessConnect(
            trans('nex_popup_cant_find_shipper', [
              bookingCode,
              receiverInfo.name,
              dropAddressInfo.address,
            ]),
            {
              title: trans('nex_notice'),
              withCloseButton: false,
              extraActions: [
                {
                  name: trans('nex_retry'),
                  onClick: () =>
                    retryOrderNowShipConnect(
                      bookingCode,
                      restaurantIdInt,
                      status,
                    ),
                },
                {
                  name: trans('nex_cancel'),
                  type: 'secondary',
                  onClick: () =>
                    cancelOrderNowShipConnect(bookingCode, {
                      restaurantId: restaurantIdInt,
                      fromStatus: status,
                      templateNoteId: TEMPLATE_NOTE_ID_NOT_FOUND_SHIPPER,
                    }),
                },
              ],
            },
          );
        }
      }
    }
  };

  sendNotificationBrowser = (messagePush) => {
    sendNotify({
      message: trans('notifications'),
      detail: messagePush,
    });
  };

  render() {
    const { NotificationOrderSubscribed } = this;
    return <NotificationOrderSubscribed />;
  }
}

const mapStateToProps = state => ({
  restaurants: state.app.restaurants,
  currentRestaurant: state.setting.currentRestaurant,
  merchantTableInfos: state.app.merchantTableInfos,
  isRingAllRestaurant: state.setting.notificationBell.isRingAllRestaurant,
});

const mapDispatchToProps = dispatch => ({
  setGeneralSuccessConnect: (message, extraData) => {
    dispatch(setGeneralSuccess(message, extraData));
  },
  startConfirmConnect: (title, message, onOk, onCancel) => {
    dispatch(
      startConfirm({
        title,
        message,
        onOk,
        onCancel,
      }),
    );
  },
  setNotificationBellConnect: (res) => {
    dispatch(setNotificationBell(res));
  },
  setRingBellConnect: (res, ringBellSound) => {
    dispatch(setRingBell(res, ringBellSound));
  },
  getListManagerOrderConnect: () => dispatch(getListManagerOrder()),
  getOrderDetailConnect: (orderCode) => {
    dispatch(getOrderDetail(orderCode));
    dispatch(setRingBell(false));
  },
  getListIdsConnect: () => dispatch(getListIds()),
  handleChangeFiltersConnect: (page, name, value) => {
    dispatch(changeFilters(page, name, value));
  },
  removeNotificationBellConnect: (orderCode) => {
    dispatch(removeNotificationBell({ orderCode }));
  },
  cancelOrderNowShipConnect: (...params) => {
    dispatch(cancelOrderNowShip(...params));
  },
  retryOrderNowShipConnect: (...params) => {
    dispatch(retryOrderNowShip(...params));
  },
  getDetailOrderNowShipConnect: (...params) =>
    dispatch(getDetailOrderNowShip(...params)),
});

export default withMqtt(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withRouter(NotificationBellWrapper)),
);



// WEBPACK FOOTER //
// ./foody/src/layout/components/Header/components/NotificationBellWrapper.jsx